module.exports = __webpack_public_path__ + "img/NXN3.b031107c.png";